module.exports = __webpack_public_path__ + "img/conference2.ce95a193.png";